// Consistent retailer color assignments for chart series.
// Colors from brand guidelines, chosen for WCAG contrast on light and dark backgrounds.

export const RETAILER_COLORS: Record<string, string> = {
  Amazon: "#ff9900",
  "Best Buy": "#0046be",
  Walmart: "#0071dc",
  Target: "#cc0000",
  Costco: "#e31837",
  "Samsung.com": "#1428a0",
  "LG.com": "#a50034",
};

const FALLBACK_COLORS = [
  "#6741d9",
  "#099268",
  "#e8590c",
  "#862e9c",
  "#2b8a3e",
  "#c92a2a",
  "#1864ab",
];

export function getRetailerColor(retailerName: string): string {
  if (retailerName in RETAILER_COLORS) {
    return RETAILER_COLORS[retailerName];
  }
  let hash = 0;
  for (let i = 0; i < retailerName.length; i++) {
    hash = (hash * 31 + retailerName.charCodeAt(i)) | 0;
  }
  return FALLBACK_COLORS[Math.abs(hash) % FALLBACK_COLORS.length];
}

export function getRetailerColors(
  retailers: string[],
): Record<string, string> {
  const result: Record<string, string> = {};
  for (const name of retailers) {
    result[name] = getRetailerColor(name);
  }
  return result;
}
